//import axios from 'axios';
import axios from '../utils/axios'

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getAllDoctors = (clinicId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors");
}
const getDoctorById = (clinicId, doctorId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId);
}
const getDoctorHours = (clinicId, doctorId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/hours");
}
const updateDoctorHours = (clinicId, doctorId, data) => {
    return axios.put(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/hours", data);
}
const syncDoctorHoursFromClinic = (clinicId, doctorId) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/hours/sync-clinic-hours");
}
const getCustomHours = (clinicId, doctorId, pageNo = 0, pageSize = 5) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours?pageNo=" + pageNo + "&pageSize=" + pageSize);
}
const addCutomHour = (clinicId, doctorId, data) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours", data)
}
const deleteCustomHour = (clinicId, doctorId, customHourId) => {
//{{server_path}}/{{admin_path}}/clinics/{{eos_id}}//bookings/doctors/{{doctorId}}/custom-hours/{{customWorkingHoursId}}
    return axios.delete(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/custom-hours/" + customHourId)
}
const addUpdateDoctor = (clinicId, data) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/doctors", data)
}

const getApptTypeToDoctor = (clinicId, doctorId, userId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/" + userId + "/appt-types");
}
const deleteApptTypeToDoctor = (clinicId, doctorId, userId, data) => {
    return axios.delete(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/" + userId + "/appt-types", {data: data});
}
const addUpdateApptTypeToDoctor = (clinicId, doctorId, userId, data) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/doctors/" + doctorId + "/" + userId + "/appt-types", data);
}
const getAllApptType = (clinicId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/appt-types");
}
const addUpdateBookingType = (clinicId, data) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/bookings/appt-types", data)
}
const deleteBookingType = (clinicId, bookingtypeid) => {
    return axios.delete(API_URL + "clinics/" + clinicId + "/bookings/appt-types/" + bookingtypeid)
}

const getBookingAppointmentRequests = (clinicId, pageNo = 0, pageSize = 20) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/bookings/appt-requests?pageNo=" + pageNo + "&pageSize=" + pageSize);
}

const clinicBookingService = {
    getAllDoctors,
    getDoctorById,
    getDoctorHours,
    updateDoctorHours,
    syncDoctorHoursFromClinic,
    getCustomHours,
    addCutomHour,
    deleteCustomHour,
    addUpdateDoctor,
    getApptTypeToDoctor,
    deleteApptTypeToDoctor,
    addUpdateApptTypeToDoctor,
    getAllApptType,
    addUpdateBookingType,
    deleteBookingType,
    getBookingAppointmentRequests
}

export default clinicBookingService;